const waContactIndexCache = new WeakMap<object, Map<string, string>>();

/**
 * Resolve a DBWaContactsCacheReducer entity by serialized chat id across every
 * shape the cache holds:
 *  - extension (live waQueryContactsAndChatsTool, lean shape post-#63/#64):
 *    keyed by `_id` === chatId, only top-level `chatId` — no nested `id`
 *  - website (DB wa-contacts-cache doc): `_id` is the serialized id, full
 *    contact objects with `id._serialized`
 * O(1) direct-key lookup first; falls back to a per-entities-object index
 * (WeakMap-cached, rebuilt only when the entities object identity changes).
 * Single source of truth — used by ContactAvatar and the profile-pic thunks;
 * do NOT re-implement this lookup with a per-id query scan.
 */
export function getWaContactBySerializedId(entities: any, serializedId: string): any {
    if (!serializedId || !entities) return null;
    if (entities[serializedId]) return entities[serializedId];

    let index = waContactIndexCache.get(entities);
    if (!index) {
        index = new Map();
        for (const key of Object.keys(entities)) {
            const e = entities[key];
            const sid = e?.id?._serialized || e?.chatId || e?._serialized || e?._id;
            if (sid) index.set(sid, key);
        }
        waContactIndexCache.set(entities, index);
    }
    const entityKey = index.get(serializedId);
    return entityKey ? entities[entityKey] : null;
}
